import { useEffect, useState } from "react";
import axios from "axios";
import { Star, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Stars = ({ n }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={14} className={i <= n ? "text-coral fill-coral" : "text-amyu-cream"} />
    ))}
  </div>
);

export const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    axios
      .get(`${API}/reviews`)
      .then((r) => setReviews(r.data.reviews || []))
      .catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section id="avis" className="py-16 md:py-24" data-testid="reviews">
      <div className="max-w-6xl mx-auto px-5">
        <div className="text-center mb-10">
          <span className="text-xs uppercase tracking-[0.24em] text-coral font-medium">Ils ont goûté</span>
          <h2 className="font-display text-4xl md:text-5xl mt-2 leading-tight">
            Ils en <span className="italic text-coral">parlent mieux que nous ♡</span>
          </h2>
        </div>
        <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 md:grid md:grid-cols-3 md:overflow-visible md:gap-6">
          {reviews.map((r) => (
            <article
              key={r.id}
              data-testid={`review-${r.id}`}
              className="snap-start shrink-0 w-[85%] md:w-auto bg-white/85 backdrop-blur-md rounded-3xl p-6 border border-amyu/30"
            >
              <Stars n={r.rating} />
              <p className="mt-3 text-sm text-amyu-ink leading-relaxed">« {r.text} »</p>
              <div className="mt-4 pt-3 border-t border-dashed border-amyu/40 flex items-center justify-between text-xs">
                <span className="font-medium">{r.author}</span>
                {r.verified && (
                  <span className="inline-flex items-center gap-1 text-amyu-pistachio-dark">
                    <CheckCircle2 size={11} /> Vérifié
                  </span>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
